<template>
  <a
    class="navbar-brand d-none d-sm-block"
    href="#">
    <!-- Cheney Logo -->
    <img
      v-if="env == 'EJW-CHENEY'"
      :src="cheneyLogo"
      class="img-fluid"
      style="max-height: 60px;"
      @click="goto('PrivateHome')">
    <!-- EJW Logo -->
    <img
      v-else-if="env == 'EJW'"
      :src="ejwLogo"
      class="img-fluid"
      style="max-height: 60px;">
    <!-- Merit Supply Logo -->
    <img
      v-else-if="env == 'LAN' && !vShow && company == 'Merit Supply'" 
      class="img-fluid"
      @click="goto('PrivateHome')"
      :src="meritLogo"
      style="max-height: 60px; padding: 0px 30px;"/>
    <!-- Lancaster vShow Logo -->
    <img
      v-else-if="env == 'LAN' && vShow"
      :src="vShowLogo"
      class="img-fluid"
      style="max-height: 60px;">
    <!-- Lancaster Standard Logo -->
    <img
      v-else-if="env == 'LAN' && !vShow" 
      class="img-fluid"
      style="width:240px;"
      @click="goto('PrivateHome')"
      :src="company == 'Lancaster Canada' ? logoCAD : logo"/>
  </a>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  // Initialize
  const props = defineProps(['env', 'company', 'vShow'])
  const router = useRouter()

  // Methods
  const goto = (routeName)=>{
    router.push({name: routeName})
  }
  
  const logo = require('../../../../assets/images/lan/LogoColor.png')
  const logoCAD = require('../../../../assets/images/lan/Logo_CAD.png')
  const vShowLogo = require('../../../../assets/images/lan/virtual_show/vShowLogoLight.png')
  // const vShowLogoCAD = require('../../../../assets/images/lan/virtual_show/vShowLogoCAD.jpg')
  const cheneyLogo = require('../../../../assets/images/cheney/CheneyLogoLight.png')
  const ejwLogo = require('../../../../assets/images/ejw/EJW_Logo_White.png')
  const meritLogo = require('../../../../assets/images/merit_supply/meritSupplyLogo-white.png')
</script>